import { queryOptions } from "@tanstack/react-query";
import { patientApi } from "./ApiClient";
import { z } from "zod";

export const otpSchema = z.object({
  code: z.string(),
  otpLifetimeInMinutes: z.int(),
});

export const generateOtp = async (patientId: string) => {
  const parsedResponse = await patientApi
    .post(`/ambulating/patients/${patientId}/care/otp`)
    .json(otpSchema);
  return parsedResponse;
};

const pinSchema = z.object({ pin: z.string() });
export const generateTemporaryPin = async (patientId: string) => {
  const parsedPin = (
    await patientApi
      .post(`/ambulating/patients/${patientId}/care/pin-temporary`)
      .json(pinSchema)
  ).pin;
  return parsedPin;
};

export const signOutPatient = async (patientId: string) => {
  await patientApi.delete(`/ambulating/patients/${patientId}/care/session`);
};

const signedInSchema = z.object({ isSignedInToCare: z.boolean() });
const fetchPatientSignInStatus = async (patientId: string) => {
  const patientIsSignedIn = await patientApi
    .get(`/ambulating/patients/${patientId}/care/session`)
    .json(signedInSchema);
  return patientIsSignedIn;
};

const TEN_SECONDS = 10 * 1000;
export const isPatientSignedInQueryOptions = (patientId: string) =>
  queryOptions({
    queryKey: ["is-patient-signed-in", patientId],
    queryFn: async () => {
      const { isSignedInToCare } = await fetchPatientSignInStatus(patientId);
      return isSignedInToCare;
    },
    // Lacking SSE, keep status updated
    refetchInterval: TEN_SECONDS,
  });
